import { useEffect, useState } from 'react';
import { HeaderHeights } from '@adac-mp/shared';
import { useViewport } from './useViewport';

interface IOffsets {
	topOffset: number;
}

export const useHeaderNavbarOffset = (): IOffsets => {
	const { viewport } = useViewport();
	const [topOffset, setTopOffset] = useState(
		viewport === 'desktop' ? Number(HeaderHeights.M) : Number(HeaderHeights.S),
	);
	useEffect(() => {
		const header = document.querySelector('header');
		const headerHeight = header?.clientHeight ?? Number(HeaderHeights.S);
		const navBar = document.querySelector('nav');
		const navBarHeight = navBar?.clientHeight ?? Number(HeaderHeights.XS);
		const desktopHeightOffset = headerHeight + navBarHeight;
		const mobileHeightOffset = headerHeight;
		setTopOffset(viewport === 'desktop' ? desktopHeightOffset : mobileHeightOffset);
		const calculateOffset = () => {
			if (viewport === 'desktop') {
				setTopOffset(window.scrollY <= headerHeight ? desktopHeightOffset - window.scrollY : navBarHeight);
			}
		};
		window.addEventListener('scroll', calculateOffset);
		return () => window.removeEventListener('scroll', calculateOffset);
	}, [viewport]);
	return { topOffset };
};
